export let ApiResponseStatus;
(function (ApiResponseStatus) {
  ApiResponseStatus["LOADING"] = "LOADING";
  ApiResponseStatus["ERROR"] = "ERROR";
  ApiResponseStatus["SUCCESS"] = "SUCCESS";
  ApiResponseStatus["UNINITIALIZED"] = "UNINITIALIZED";
})(ApiResponseStatus || (ApiResponseStatus = {}));
export let SubmissionApiFailureResponse;
(function (SubmissionApiFailureResponse) {
  SubmissionApiFailureResponse["DEAL_ID_ERROR"] = "DEAL_ID_ERROR";
  SubmissionApiFailureResponse["GENERIC_SUBMISSION_ERROR"] = "GENERIC_SUBMISSION_ERROR";
})(SubmissionApiFailureResponse || (SubmissionApiFailureResponse = {}));